import { memo } from "react";

const Help = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_276_2851)">
      <path d="M19 0H0V19H19V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M9.49999 17.4167C11.6861 17.4167 13.6653 16.5306 15.0979 15.098C16.5305 13.6653 17.4167 11.6861 17.4167 9.50004C17.4167 7.31393 16.5305 5.33477 15.0979 3.90211C13.6653 2.46948 11.6861 1.58337 9.49999 1.58337C7.31389 1.58337 5.33472 2.46948 3.90206 3.90211C2.46943 5.33477 1.58333 7.31393 1.58333 9.50004C1.58333 11.6861 2.46943 13.6653 3.90206 15.098C5.33472 16.5306 7.31389 17.4167 9.49999 17.4167Z"
        stroke="currentColor"
        strokeWidth="1.58333"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 11.3308V9.74744C10.8117 9.74744 11.875 8.68411 11.875 7.37244C11.875 6.06076 10.8117 4.99744 9.5 4.99744C8.18833 4.99744 7.125 6.06076 7.125 7.37244"
        stroke="currentColor"
        strokeWidth="1.58333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.50001 14.8932C10.0465 14.8932 10.4896 14.4502 10.4896 13.9036C10.4896 13.3571 10.0465 12.9141 9.50001 12.9141C8.95348 12.9141 8.51042 13.3571 8.51042 13.9036C8.51042 14.4502 8.95348 14.8932 9.50001 14.8932Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_276_2851">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Help);
